import { User } from "@/features/authentication/models/user";
import { submitFirstTouchAttribution } from "../services/analytics/attribution";

interface AuthenticationProvider {
	isAuthenticated: boolean;
	user: undefined | User;
	setUser(user: User): Promise<void>;
	signin(user: User | User): Promise<void>;
	signout(): Promise<void>;
	updateInformation(
		url?: string,
		fullName?: string,
		onReload?: () => void
	): Promise<void>;
}

export const AuthenticationProvider: AuthenticationProvider = {
	isAuthenticated: false,
	user: undefined,
	async setUser(user: User) {
		window.localStorage.setItem("user", JSON.stringify(user));
		AuthenticationProvider.user = {
			id: user.id,
			email: user.email,
			emailVerified: user.emailVerified,
			fullName: user.fullName,
			accessToken: user.accessToken,
		};
		await submitFirstTouchAttribution(user.accessToken);
		window.dispatchEvent(new Event("reelrewards:auth-changed"));
	},
	async signin(user: User) {
		window.localStorage.setItem("user", JSON.stringify(user));
		AuthenticationProvider.isAuthenticated = true;
		AuthenticationProvider.user = user;
		await submitFirstTouchAttribution(user.accessToken);
		window.dispatchEvent(new Event("reelrewards:auth-changed"));
	},
	async signout() {
		window.localStorage.removeItem("user");
		AuthenticationProvider.isAuthenticated = false;
		AuthenticationProvider.user = undefined;
		window.dispatchEvent(new Event("reelrewards:auth-changed"));
	},
	async updateInformation(url, fullName, onReload) {
		if (!this.user) return;
		if (url) this.user.profilePictureUrl = url;
		if (fullName) this.user.fullName = fullName;

		window.localStorage.setItem("user", JSON.stringify(this.user));
		window.dispatchEvent(new Event("reelrewards:auth-changed"));
		if (onReload) onReload();
	},
};
